import React, { useEffect, useState } from "react";
import {
  showError,
  showSuccess,
} from "../../../../../../../../utils/showMessage";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Images from "../../../../../../../../utils/images.js";
import CrossButton from "../../../../../../../common/ButtonSpinner/CrossButton";
import GeneralButton from "../../../../../../../common/SaveButton/GeneralButton";
import CustomModal from "../../../../../../../common/CustomModal/CustomModal.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from "@mui/material";
import { validateDatabaseName } from "../../utils/databaseValidation.js";

const RenameItemPopup = ({
  visible,
  onClose,
  open,
  setOpenRenameItemPopup,
  onSave,
  currentName,
  newName,
  setNewName,
  loading,
  setLoading,
  renameFunction,
  successMessage,
  errorMessage,
  itemType,
  databaseInfo,
}) => {
  useEffect(() => {
    setNewName(currentName);
  }, [visible, currentName, setNewName]);

  const handleSave = async () => {
    if (!newName.trim()) {
      showError(`Please enter a valid ${itemType.toLowerCase()} name.`);
      return;
    }

    // Database name validation
    if (itemType === "Database") {
      // Check for spaces
      if (newName.includes(" ")) {
        showError("Database name cannot contain spaces");
        return;
      }
      
      const validation = validateDatabaseName(newName);
      if (!validation.isValid) {
        showError(validation.error);
        return;
      }
    }
    setLoading(true);
    try {
      const response = await renameFunction(newName);
      if (response.error) {
        // Use backend error message if available, otherwise fallback to default
        const errorMessage = response.error || `Error while renaming ${itemType.toLowerCase()}. Please try again.`;
        showError(errorMessage);
      } else {
        onSave(newName);
        // Use backend success message if available, otherwise fallback to default
        const successMessage = response.data?.message || `${itemType} renamed successfully!`;
        showSuccess(successMessage);
        onClose();
      }
    } catch (error) {
      showError(
        `Error while renaming ${itemType.toLowerCase()}. Please try again.`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal 
      open={visible} 
      handleClose={onClose}
      width="40%"
    >
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <div className="d-flex align-items-center mb-1">
              {databaseInfo === "MySQL" && (
                <img src={Images.mysql} alt="MySQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "PostgreSQL" && (
                <img src={Images.pssql} alt="PostgreSQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "MSSQL" && (
                <img src={Images.mssql} alt="MSSQL" width="24" height="24" className="me-2" />
              )}
              <h3 className="border-0 customize-column-name mb-0">
                Rename {itemType}
              </h3>
            </div>
            <p className="text-muted mb-0 fs-14px">
              Change the name of <code className="bg-light px-2 py-1 rounded">{currentName}</code> {itemType.toLowerCase()}
            </p>
          </div>
          <CrossButton onClick={onClose} />
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <div className="mb-4">
            <Form.Label className="input_label d-flex align-items-center mb-2">
              New {itemType} Name
              <span className="text-danger ms-1">*</span>
              <Tooltip
                title={itemType === "Database" 
                  ? `The ${itemType.toLowerCase()} name can contain letters, numbers, underscores, hyphens, and dots. It cannot exceed 64 characters and cannot start/end with numbers, hyphens, or dots.`
                  : `The ${itemType.toLowerCase()} name must only contain alphanumeric characters and underscores (_). Special characters are not allowed.`
                }
                placement="top-end"
              >
                <img
                  src={Images.InfoIcon}
                  alt="info"
                  width="15"
                  height="15"
                  className="cursor_pointer ms-2"
                />
              </Tooltip>
            </Form.Label>
            <Form.Control
              className="form_input_field"
              type="text"
              value={newName}
              onChange={(event) => setNewName(event.target.value)}
              placeholder={`Enter new ${itemType.toLowerCase()} name`}
            />
          </div>

          <Row className="pt-4 mb-3 justify-content-end">
            <Col sm="auto">
              <GeneralButton
                onClickEvent={onClose}
                className="me-1"
                value="Cancel"
                color="#505050"
                variant="outlined"
                size="large"
              />
            </Col>
            <Col sm="auto" className="me-sm-2 p-0">
              {loading ? (
                <GeneralButton
                  variant="contained"
                  disabled={true}
                  className="me-1"
                  value={
                    <img src={Images.Loader} width="26px" height="26px" />
                  }
                  size="large"
                />
              ) : (
                <GeneralButton
                  className="me-1"
                  value="Rename"
                  variant="contained"
                  size="large"
                />
              )}
            </Col>
          </Row>
        </Form>
      </div>
    </CustomModal>
  );
};

export default RenameItemPopup;
